import { render } from "./MainSidebar.vue?vue&type=template&id=7cf14e51&scoped=true&ts=true"
import script from "./MainSidebar.vue?vue&type=script&lang=ts"
export * from "./MainSidebar.vue?vue&type=script&lang=ts"

import "./MainSidebar.vue?vue&type=style&index=0&id=7cf14e51&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf14e51"]])

export default __exports__